import React, { useEffect, useRef, useState } from 'react';
import './News.css';
import Swapers from '../../Carousel/Swapers/Swapers';
import { getAllDataWithFlag } from '../../../services/CommonService';
import Shimmer from '../../Shimmer/Shimmer';
import { imgURL } from '../../Config';

const News = ({ newsData }) => {
  if (!newsData?.length) {
    return <Shimmer />
  }

  const swiperParams = {
    slidesPerView: 2,
    spaceBetween: 30,
    loop: true,
    autoplay: { delay: 3000, disableOnInteraction: false },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: (newsData?.length > 1) ? 1 : newsData?.length },
      992: { slidesPerView: (newsData?.length > 1) ? 1 : newsData?.length },
      1200: { slidesPerView: (newsData?.length > 1) ? 1 : newsData?.length },
      1400: { slidesPerView: (newsData?.length > 1) ? 1 : newsData?.length },
    },
    equalizeHeights: true,
    slidesData: newsData, // Pass your array of course data
    renderSlide: (course) => ( // Define how to render each course
      <div
        className="feature-four__item wow fadeInUp"
        data-wow-duration="1500ms"
        data-wow-delay="100ms"
      >
        <div className="news-card d-flex">
          <div className="news-card-image">
            <img src={`${imgURL}news_image/${course.image_path}`} alt="news" />
          </div>
          <div className="news-card-content">
            <h6 className="feature-four__item__title">{course.title}</h6>
          </div>
        </div>

      </div>
    )
  };

  return (
    <section className="feature-four">
      <div className="container">
        <Swapers {...swiperParams} className="feature-four__carousel acwadam-owl__carousel" />
      </div>
    </section>
  );
};

export default News;